import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
// import MenuCart from "./sub-components/MenuCart"; // commented out as no longer needed
import { deleteFromCart } from "../../redux/actions/cartActions";
import { deleteUser } from "../../redux/actions/userAction";
import { AppInstance } from "../../api/instance";
import { useAuthContext } from "../../contexts/AuthContext";
import { useCartDrawer } from "../../contexts/CartDrawerContext";

const IconGroup = ({
  currency,
  cartData,
  wishlistData,
  compareData,
  deleteFromCart,
  iconWhiteClass,
  userInfo,
  deleteUser,
}) => {
  const addToast = () => {};
  const { openAuthModal } = useAuthContext();
  const { openCartDrawer } = useCartDrawer();

  // Helper function to handle auth-protected actions
  const handleAuthProtectedAction = (e, action) => {
    if (!userInfo?.user) {
      e.preventDefault();
      openAuthModal();
    } else {
      if (action === 'cart') {
        openCartDrawer();
      } else if (action === 'wishlist') {
        window.location.href = process.env.PUBLIC_URL + "/wishlist";
      }
    }
  };
  const handleClick = (e) => {
    e.stopPropagation(); // Prevent event from bubbling up to document

    // If user is not logged in and this is the account button, open auth modal directly
    if (!userInfo?.user && e.currentTarget.classList.contains('account-setting-active')) {
      openAuthModal();
      return;
    }

    // Close all other modals first
    const allDropdowns = document.querySelectorAll(
      ".account-dropdown, .search-content, .shopping-cart-content"
    );
    allDropdowns.forEach((dropdown) => {
      if (dropdown !== e.currentTarget.nextSibling) {
        dropdown.classList.remove("active");
      }
    });

    // Toggle the clicked modal
    e.currentTarget.nextSibling.classList.toggle("active");
  };

  // Add click outside handler to close modals
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      const dropdowns = document.querySelectorAll(
        ".account-dropdown, .search-content, .shopping-cart-content"
      );
      dropdowns.forEach((dropdown) => {
        if (
          dropdown.classList.contains("active") &&
          !dropdown.contains(event.target)
        ) {
          dropdown.classList.remove("active");
        }
      });
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const triggerMobileMenu = () => {
    const offcanvasMobileMenu = document.querySelector(
      "#offcanvas-mobile-menu"
    );
    offcanvasMobileMenu.classList.add("active");
  };

  AppInstance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error?.response?.status === 401) {
        deleteUser(addToast);
      } else {
        return Promise.reject(error);
      }
    }
  );

  return (
    <div
      className={`header-right-wrap ${iconWhiteClass ? iconWhiteClass : ""}`}
    >
      <div className="same-style header-search d-none d-lg-block">
        <button className="search-active" onClick={(e) => handleClick(e)}>
          <i className="pe-7s-search" />
        </button>
        <div className="search-content">
          <form action="#">
            <input type="text" placeholder="Search" />
            <button className="button-search">
              <i className="pe-7s-search" />
            </button>
          </form>
        </div>
      </div>
      <div className="same-style account-setting d-none d-lg-block">
        <button
          className="account-setting-active d-flex align-items-center justify-content-center"
          onClick={(e) => handleClick(e)}
        >
          <i className="pe-7s-user-female" />
        </button>
        {userInfo?.user && (
          <div className="account-dropdown">
            <ul>
              <li>
                <Link to={process.env.PUBLIC_URL + "/my-account"}>
                  My Account
                </Link>
              </li>
              <li>
                <Link to={process.env.PUBLIC_URL + "/my-orders"}>My Oders</Link>
              </li>
              <li onClick={() => deleteUser(addToast)}>
                <Link to={"#"}>Logout</Link>
              </li>
            </ul>
          </div>
        )}
      </div>
      {/* <div className="same-style header-compare">
        <Link to={process.env.PUBLIC_URL + "/compare"}>
          <i className="pe-7s-shuffle" />
          <span className="count-style">
            {compareData && compareData.length ? compareData.length : 0}
          </span>
        </Link>
      </div> */}
      <div className="same-style header-wishlist">
        <button 
          onClick={(e) => handleAuthProtectedAction(e, 'wishlist')}
          style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
        >
          <i className="pe-7s-like" />
          <span className="count-style">
            {wishlistData && wishlistData.length ? wishlistData.length : 0}
          </span>
        </button>
      </div>
      <div className="same-style cart-wrap d-none d-lg-block">
        <button 
          className="icon-cart"
          onClick={(e) => handleAuthProtectedAction(e, 'cart')}
          style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
        >
          <i className="pe-7s-shopbag" />
          <span className="count-style">
            {cartData && cartData.length ? cartData.length : 0}
          </span>
        </button>
        {/* menu cart - commented out to redirect to cart page instead */}
        {/* <MenuCart
          cartData={cartData}
          currency={currency}
          deleteFromCart={deleteFromCart}
        /> */}
      </div>
      <div className="same-style cart-wrap d-block d-lg-none">
        <button 
          className="icon-cart"
          onClick={(e) => handleAuthProtectedAction(e, 'cart')}
          style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
        >
          <i className="pe-7s-shopbag" />
          <span className="count-style">
            {cartData && cartData.length ? cartData.length : 0}
          </span>
        </button>
      </div>
      <div className="same-style mobile-off-canvas d-block d-lg-none">
        <button
          className="mobile-aside-button"
          onClick={() => triggerMobileMenu()}
        >
          <i className="pe-7s-menu" />
        </button>
      </div>

    </div>
  );
};

IconGroup.propTypes = {
  cartData: PropTypes.array,
  compareData: PropTypes.array,
  currency: PropTypes.object,
  iconWhiteClass: PropTypes.string,
  deleteFromCart: PropTypes.func,
  wishlistData: PropTypes.array,
  userInfo: PropTypes.object,
  deleteUser: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    currency: state.currencyData,
    cartData: state.cartData,
    wishlistData: state.wishlistData,
    compareData: state.compareData,
    userInfo: state.userInfo,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    deleteFromCart: (item, addToast) => {
      dispatch(deleteFromCart(item, addToast));
    },
    deleteUser: (addToast) => {
      dispatch(deleteUser(addToast));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(IconGroup);
